import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import stl from "./InfoComponent.module.css";
import { useTranslation } from "@i18n";
import Input from "@/components/UiKit/Input/Input";
import { useState, useRef, useEffect } from "react";
import Select from "@/components/UiKit/Select/Select";
import { api__getCitiesDropDown } from "@/apis/assets/api__get_cities_drop_down";
import postUserInfo from "@/apis/freeFinance/postUserInfo";
import { CDN_LINK } from "@globalConfig";
import RadioButtonMD from "./RadioButtonMD";
import ChangeAccountVerificationModal from "@/_MiniApps/auth/ui/ChangeAccountVerificationModal/ChangeAccountVerificationModal";
import RequiredDocuments from "@/pages/checkout/arib-finance/component/RequiredDocuments";
import OtpVerification from "@/_MiniApps/auth/ui/OTP/OtpVerification";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useHelpers from "@hooks/useHelpers";
import useApi from "@hooks/useApi";
import Loader from "@componentsShared/Loader/Loader";
import { handleHasAccountEvent } from "@/utils/common";
import { useLang } from "@/common/Contexts/LanguageContext";
import InputPhoneNumber from "@componentsShared/InputPhoneNumber/InputPhoneNumber";
var InfoComponent = function InfoComponent(_ref) {
  var post_id = _ref.post_id,
    queryParams = _ref.queryParams,
    setIsOtpStep = _ref.setIsOtpStep,
    updateLoader = _ref.updateLoader,
    setMobileNUmberForEvent = _ref.setMobileNUmberForEvent,
    onFormUpdated = _ref.onFormUpdated,
    onFormCompleted = _ref.onFormCompleted,
    warrantyId = _ref.warrantyId;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var _useAuthActions = useAuthActions(),
    logout = _useAuthActions.logout;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useState = useState({
      postId: post_id,
      whatsapp_optin: 1,
      applicant_name: (user === null || user === void 0 ? void 0 : user.full_name) || null,
      mobile_number: (user === null || user === void 0 ? void 0 : user.phone_number) || null,
      city_id: (user === null || user === void 0 ? void 0 : user.city_id) || null,
      gender: null,
      id_number: null
    }),
    data = _useState[0],
    setData = _useState[1];
  var _useState2 = useState(false),
    showOtp = _useState2[0],
    setShowOtp = _useState2[1];
  var _useState3 = useState({
      value: "",
      error: ""
    }),
    otp = _useState3[0],
    setOtp = _useState3[1];
  var _useState4 = useState(false),
    isOtpLimitExceeded = _useState4[0],
    setIsOtpLimitExceeded = _useState4[1];
  var _useState5 = useState(false),
    showVerificationModal = _useState5[0],
    setShowVerificationModal = _useState5[1];
  var _useState6 = useState(null),
    order_id = _useState6[0],
    setOrderId = _useState6[1];
  var _useState7 = useState(null),
    uuid = _useState7[0],
    setUuid = _useState7[1];
  var _useState8 = useState(null),
    errors = _useState8[0],
    setErrors = _useState8[1];
  var _useApi = useApi([], api__getCitiesDropDown),
    _useApi2 = _slicedToArray(_useApi, 3),
    loadingCities = _useApi2[0],
    error = _useApi2[1],
    cities = _useApi2[2];
  var initialTrackedValuesRef = useRef(null);
  useEffect(function () {
    return function () {
      setIsOtpLimitExceeded(false);
      setShowOtp(false);
    };
  }, []);
  var hasUpdatedCheckoutForm = Boolean(initialTrackedValuesRef.current && (initialTrackedValuesRef.current.applicant_name !== (data["applicant_name"] || "") || initialTrackedValuesRef.current.mobile_number !== (data["mobile_number"] || "") || initialTrackedValuesRef.current.city_id !== (data["city_id"] ? String(data["city_id"]) : "") || initialTrackedValuesRef.current.id_number !== (data["id_number"] || "")));
  useEffect(function () {
    setMobileNUmberForEvent(data["mobile_number"]);
  }, [data]);
  useEffect(function () {
    if (onFormUpdated) {
      onFormUpdated(hasUpdatedCheckoutForm);
    }
  }, [hasUpdatedCheckoutForm, onFormUpdated]);
  useEffect(function () {
    if (initialTrackedValuesRef.current) return;
    initialTrackedValuesRef.current = {
      applicant_name: data["applicant_name"] || "",
      mobile_number: data["mobile_number"] || "",
      city_id: data["city_id"] ? String(data["city_id"]) : "",
      id_number: data["id_number"] || ""
    };
  }, [data]);
  var updateData = function updateData(key, value) {
    setData(function (prevData) {
      return _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, key, value));
    });
  };
  var updateErrors = function updateErrors(key, value) {
    setErrors(function (prevData) {
      return _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, key, value));
    });
  };
  var sendData = function sendData() {
    if (data["mobile_number"] != null && isLoggedIn && (user === null || user === void 0 ? void 0 : user.phone_number) != data["mobile_number"] && !showVerificationModal) {
      setShowVerificationModal(true);
      return;
    }
    updateLoader(true);
    var financeData = sessionStorage.getItem("installment-calculator-".concat(post_id));
    var parsedData = JSON.parse(financeData);
    if (financeData) {
      if (Object.keys(parsedData).length > 0) {
        setData(function (prevData) {
          return _objectSpread(_objectSpread({}, prevData), parsedData);
        });
      }
    }
    var submitData = _objectSpread(_objectSpread({}, data), {}, {
      first_payment: parsedData === null || parsedData === void 0 ? void 0 : parsedData.down_payment,
      monthly_installment: parsedData === null || parsedData === void 0 ? void 0 : parsedData.monthly_installment,
      installment_period: parsedData === null || parsedData === void 0 ? void 0 : parsedData.period,
      last_payment: parsedData === null || parsedData === void 0 ? void 0 : parsedData.last_payment
    }, warrantyId ? {
      warranty_id: warrantyId
    } : {});
    postUserInfo(submitData).then(function (res) {
      if (res.data.code === 200) {
        var _res$data, _res$data$data;
        if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.status) === 0) {
          onFormCompleted === null || onFormCompleted === void 0 ? void 0 : onFormCompleted();
          navigateTo("/finance/rejected?haveanotherOrder=1&post_id=" + post_id);
        } else {
          var _res$data2, _res$data2$data, _res$data3, _res$data3$data;
          setOrderId(res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$data = _res$data2.data) === null || _res$data2$data === void 0 ? void 0 : _res$data2$data.order_id);
          setUuid(res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : (_res$data3$data = _res$data3.data) === null || _res$data3$data === void 0 ? void 0 : _res$data3$data.order_uuid);
          setIsOtpStep(true);
          setShowOtp(true);
          updateLoader(false);
          setShowVerificationModal(false);
        }
      } else {
        updateLoader(false);
        if (res.data.code === 230) {
          setErrors(res.data.errors);
        }
      }
    });
  };
  var verifyOtpCb = function verifyOtpCb(userData) {
    if (!isLoggedIn) {
      handleHasAccountEvent({
        hasAccount: userData.has_account,
        status: "Success",
        phone_number: userData.phone_number,
        lang: lang,
        referral_location: "finance_order"
      });
    }
    onFormCompleted === null || onFormCompleted === void 0 ? void 0 : onFormCompleted();
    setIsOtpStep(false);
    updateLoader(false);
    navigateTo("/finance-apply-free/".concat(post_id), {
      financestep: 2,
      uuid: uuid
    });
  };
  var renderer = function renderer() {
    if (showOtp) {
      return /*#__PURE__*/React.createElement(OtpVerification, {
        FIX_ME__extra_params: {
          order_id: order_id.toString(),
          is_finance: true
        },
        source: "finance_order_verify",
        after_verify_callback: verifyOtpCb,
        scenario: "signup",
        phone_number: data["mobile_number"],
        onEditNumber: function onEditNumber() {
          setShowOtp(false);
          setOtp({
            value: "",
            error: ""
          });
        },
        design: {
          btnText: tShort("phone_number_verification", {
            "ns": "otp_screen"
          }),
          label: tShort("enter_code_sent_to", {
            "ns": "otp_screen"
          }),
          className: stl.otpWrapper,
          subClassName: stl.fontSize,
          otpBtn: stl.otpBtn
          // event: event
        }
      });
    }
  };
  if (loadingCities) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.InfoComponentContainer
  }, renderer(), !showOtp && !isOtpLimitExceeded && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, t("enter_information", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement(Input, {
    className: stl.formStyle,
    name: "applicant_name",
    label: t("full_name", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.applicant_name : "",
    onChange: function onChange(event) {
      updateData("applicant_name", event.currentTarget.value);
    },
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.applicant_name) && updateErrors("applicant_name", "");
    },
    value: data["applicant_name"]
  }), /*#__PURE__*/React.createElement(RadioButtonMD, {
    selected: data["gender"],
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.gender : "",
    className: stl.formStyle,
    onChange: function onChange(event) {
      (errors === null || errors === void 0 ? void 0 : errors.gender) && updateErrors("gender", "");
      updateData("gender", event.currentTarget.value);
    },
    label: t("gender", {
      ns: "web_checkout_finance"
    }),
    name: "name",
    options: [{
      title: t("male", {
        ns: "web_checkout_finance"
      }),
      value: "10"
    }, {
      title: t("female", {
        ns: "web_checkout_finance"
      }),
      value: "20"
    }]
  }), /*#__PURE__*/React.createElement(Input, {
    className: stl.formStyle,
    maxLength: 10,
    name: "id_number",
    label: t("identification_number", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    inputMode: "numeric",
    onlyNumbers: true,
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.id_number : "",
    onChange: function onChange(event) {
      updateData("id_number", event.currentTarget.value);
    },
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.id_number) && updateErrors("id_number", "");
    },
    value: data["id_number"]
  }), /*#__PURE__*/React.createElement(InputPhoneNumber, {
    className: stl.formStyle,
    defaultValue: data["mobile_number"],
    onChange: function onChange(value) {
      // Update the state with the converted value
      updateData("mobile_number", value);
    },
    errorLabel: errors ? errors === null || errors === void 0 ? void 0 : errors.mobile_number : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.seller_mobile) && updateErrors("seller_mobile", "");
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: [stl.whtsFlx, stl.formStyle].join(" ")
  }, /*#__PURE__*/React.createElement("input", {
    onChange: function onChange(_) {
      var new_value = data["whatsapp_optin"] ? 0 : 1;
      updateData("whatsapp_optin", new_value);
    },
    defaultChecked: data["whatsapp_optin"],
    type: "checkbox",
    name: "whatsapp_optin"
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.boxDummy
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/wpImg.svg",
    alt: "whts",
    width: "24px",
    height: "24px"
  }), /*#__PURE__*/React.createElement("span", null, t("like_receive_updates_order_via", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement(Select, {
    name: "city_id",
    topLabel: t("city", {
      ns: "web_checkout_finance"
    }),
    type: "select",
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.city_id : "",
    onChange: function onChange(event) {
      updateData("city_id", event.currentTarget.value);
      (errors === null || errors === void 0 ? void 0 : errors.city_id) && updateErrors("city_id", "");
    }
  }, !data["city_id"] && /*#__PURE__*/React.createElement("option", {
    disabled: true,
    selected: true,
    hidden: true
  }, t("select", {
    ns: "web_checkout_finance"
  })), cities === null || cities === void 0 ? void 0 : cities.map(function (city) {
    return /*#__PURE__*/React.createElement("option", {
      selected: String(data["city_id"]) === String(city === null || city === void 0 ? void 0 : city.id),
      key: city === null || city === void 0 ? void 0 : city.id,
      value: city === null || city === void 0 ? void 0 : city.id
    }, lang === "ar" ? city === null || city === void 0 ? void 0 : city.name : (city === null || city === void 0 ? void 0 : city.name_en) || (city === null || city === void 0 ? void 0 : city.name_english) || (city === null || city === void 0 ? void 0 : city.name));
  })), /*#__PURE__*/React.createElement(RequiredDocuments, {
    blueStyle: false
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.submitData
  }, /*#__PURE__*/React.createElement("button", {
    className: "blueBtn",
    onClick: function onClick() {
      sendData();
    }
  }, /*#__PURE__*/React.createElement("strong", null, t("next_step", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", null))), /*#__PURE__*/React.createElement(ChangeAccountVerificationModal, {
    show: showVerificationModal,
    onClose: function onClose() {
      return setShowVerificationModal(false);
    },
    onSubmit: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setShowVerificationModal(false);
            _context.n = 1;
            return logout(null);
          case 1:
            sendData();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })),
    newPhoneNumber: data["mobile_number"]
  }))));
};
export default InfoComponent;